var _g, _path, _line, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLanguageSwitcherEn = function SvgLanguageSwitcherEn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 27,
    viewBox: "0 0 48 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_6973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.2444 11.488V14.099H33.6324V15.688H30.2444V18.355H34.5984V20H28.1304V9.843H34.5984V11.488H30.2444ZM44.8705 9.843V20H43.7855C43.6221 20 43.4845 19.9743 43.3725 19.923C43.2605 19.867 43.1508 19.7737 43.0435 19.643L37.9825 13.203C37.9965 13.3663 38.0058 13.5273 38.0105 13.686C38.0198 13.8447 38.0245 13.9917 38.0245 14.127V20H36.1695V9.843H37.2755C37.3641 9.843 37.4388 9.84767 37.4995 9.857C37.5648 9.86167 37.6231 9.878 37.6745 9.906C37.7258 9.92933 37.7748 9.962 37.8215 10.004C37.8681 10.046 37.9195 10.102 37.9755 10.172L43.0715 16.64C43.0528 16.4627 43.0388 16.2923 43.0295 16.129C43.0201 15.961 43.0155 15.8023 43.0155 15.653V9.843H44.8705Z",
    fill: "#1E4176"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6336 12.4622L12.7118 14.5159L12.09 16.1809L9.54547 13.6363L5.45455 17.7272L4.29681 16.5695L8.45726 12.4581C7.43456 11.3209 6.61635 10.0608 6.01909 8.72721H7.65543C8.15451 9.70086 8.78452 10.6213 9.54543 11.4681C10.7236 10.159 11.5868 8.66174 12.1391 7.08266H3V5.45449H8.72726V3.81812H10.3636V5.45449H16.0909V7.09494H13.6937C13.0964 9.02586 12.0818 10.8504 10.6582 12.4377L10.6336 12.4622ZM15.6818 10.3635H17.3182L21 20.1817H19.3637L18.4432 17.7271H14.5568L13.6364 20.1817H12L15.6818 10.3635ZM16.5 12.5439L15.1705 16.0908H17.8296L16.5 12.5439Z",
    fill: "#1E4176"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    y1: 4,
    x2: 24.5,
    y2: 25.128,
    stroke: "#1E4176"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_6973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24 3)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLanguageSwitcherEn);
export { ForwardRef as ReactComponent };